import errorImg from '@p2p/assets/img/error-image.png';
import warning1Go from '@p2p/assets/img/warning-1go.png';
import warningDrip from '@p2p/assets/img/warning-drip.png';
import warningFlash from '@p2p/assets/img/warning-flash.png';
import warningIzzi from '@p2p/assets/img/warning-izzi.png';
import warningJet from '@p2p/assets/img/warning-jet.png';
import warningLegzo from '@p2p/assets/img/warning-legzo.png';
import warningMonro from '@p2p/assets/img/warning-monro.png';
import warningSol from '@p2p/assets/img/warning-sol.png';
import warningStarda from '@p2p/assets/img/warning-starda.png';
import warningVolna from '@p2p/assets/img/warning-volna.png';
import { TGetOrderResponse } from '@p2p/services';
import classNames from 'classnames';
import { useMemo } from 'react';

import { TransferCard, TransferHead, TransferLogo } from '..';
import styles from './TransferWarning.module.scss';

type TransferWarningProps = {
  order: TGetOrderResponse;
  id: string;
};

export const TransferWarning = ({ order, id }: TransferWarningProps) => {
  const themeName: string = order?.payment_form?.split('_')?.[0];

  const warningImg = useMemo(() => {
    switch (themeName) {
      case 'fresh':
        return warningFlash;
      case 'volna':
        return warningVolna;
      case 'jet':
        return warningJet;
      case 'sol':
        return warningSol;
      case 'starda':
        return warningStarda;
      case 'drip':
        return warningDrip;
      case 'izzi':
        return warningIzzi;
      case 'legzo':
        return warningLegzo;
      case 'onego':
        return warning1Go;
      case 'monro':
        return warningMonro;
      default:
        return errorImg;
    }
  }, [themeName]);

  return (
    <main className={classNames(styles.payment_page, styles.warning, styles[themeName])}>
      <TransferLogo />
      <div className={styles.payment_dialog}>
        <TransferHead id={id} status={themeName} />
        <div className={styles.payment_dialog__body}>
          <TransferCard
            status={themeName}
            time={order?.time_left || 0}
            price={order?.expected_income}
            code={order?.currency_code_to}
          />
          <div className={styles.status_block}>
            <div>
              <img src={warningImg} alt="" />
            </div>
            <div className={styles.status_block__title}>Платёж не был завершён вовремя.</div>
            <div className={styles.status_block__description}>
              Пожалуйста, вернитесь на сайт и повторите попытку.
              {/* Если у вас возникли трудности с оплатой, обратитесь в <a href="#">службу поддержки.</a> */}
            </div>
          </div>
          <a
            href={order?.merchant_failed_page}
            className={classNames(styles.btn, styles.btn_secondary)}
          >
            Вернуться на сайт
          </a>
        </div>
      </div>
    </main>
  );
};
